<template>
  <section class="home">
    <!-- InstanceBeginEditable name="MainTtl" -->
    <div id="body" class="PageTitleStyle3">
      <h1>
        <img
          src="image/ttl_simulation_pc.webp"
          width="720"
          height="101"
          alt="保険料シミュレーション"
          class="switch"
        />
      </h1>
    </div>
    <birth-employee
      v-if="currentStep === 0"
      :employee-info="employeeInfo"
      @submit="handleSubmitEmployeeInfo"
    />
    <insurance-cards
      v-if="currentStep === 1"
      :employee-info="employeeInfo"
      @submit="handleSubmitEmployeeInfo"
    />
    <!-- Dialogs -->
    <dialog-bonus-condition
      v-model="dialogs.bonusCondition"
      @onClose="closeDialog('bonusCondition')"
    />
    <dialog-bonus-condition-insurance
      v-model="dialogs.bonusConditionInsurance"
      @onClose="closeDialog('bonusConditionInsurance')"
    />
    <dialog-about-age
      v-model="dialogs.aboutAge"
      @onClose="closeDialog('aboutAge')"
    />
    <dialog-guarantee-illness
      v-model="dialogs.guaranteeIllness"
      @onClose="closeDialog('guaranteeIllness')"
    />
    <dialog-guarantee-injury
      v-model="dialogs.guaranteeInjury"
      @onClose="closeDialog('guaranteeInjury')"
    />
    <dialog-guarantee-long-term-care
      v-model="dialogs.guaranteeLongTermCare"
      @onClose="closeDialog('guaranteeLongTermCare')"
    />
    <dialog-guarantee-reduce-income
      v-model="dialogs.guaranteeReduceIncome"
      @onClose="closeDialog('guaranteeReduceIncome')"
    />
    <dialog-guarantee-daily-trouble
      v-model="dialogs.guaranteeDailyTrouble"
      @onClose="closeDialog('guaranteeDailyTrouble')"
    />
    <dialog-guarantee-traffic-accident
      v-model="dialogs.guaranteeTrafficAccident"
      @onClose="closeDialog('guaranteeTrafficAccident')"
    />
    <dialog-web v-model="dialogs.web" @onClose="closeDialog('web')" />

    <!-- ------ -->
  </section>
</template>

<script>
import BirthEmployee from './home/BirthEmployee.vue';
import InsuranceCards from './home/InsuranceCards.vue';
import DialogBonusCondition from '@/components/dialogs/DialogBonusCondition.vue';
import DialogAboutAge from '@/components/dialogs/DialogAboutAge.vue';
import { mapActions, mapState } from 'vuex';
import DialogGuaranteeIllness from '@/components/dialogs/DialogGuaranteeIllness.vue';
import DialogGuaranteeInjury from '@/components/dialogs/DialogGuaranteeInjury.vue';
import DialogGuaranteeLongTermCare from '@/components/dialogs/DialogGuaranteeLongTermCare.vue';
import DialogGuaranteeReduceIncome from '@/components/dialogs/DialogGuaranteeReduceIncome.vue';
import DialogGuaranteeDailyTrouble from '@/components/dialogs/DialogGuaranteeDailyTrouble.vue';
import DialogGuaranteeTrafficAccident from '@/components/dialogs/DialogGuaranteeTrafficAccident.vue';
import DialogBonusConditionInsurance from '@/components/dialogs/DialogBonusConditionInsurance.vue';
import DialogWeb from '@/components/dialogs/DialogWeb.vue';
export default {
  name: 'Home',
  components: {
    BirthEmployee,
    InsuranceCards,
    DialogBonusCondition,
    DialogAboutAge,
    DialogGuaranteeIllness,
    DialogGuaranteeInjury,
    DialogGuaranteeLongTermCare,
    DialogGuaranteeReduceIncome,
    DialogGuaranteeDailyTrouble,
    DialogGuaranteeTrafficAccident,
    DialogBonusConditionInsurance,
    DialogWeb,
  },
  data() {
    return {
      currentStep: 0,
      employeeInfo: null,
    };
  },
  computed: {
    ...mapState({
      dialogs: (state) => state.dialog.list,
    }),
  },
  methods: {
    ...mapActions('dialog', ['openDialog', 'closeDialog']),
    handleSubmitEmployeeInfo(info) {
      this.employeeInfo = info;
      this.currentStep === 0 ? (this.currentStep = 1) : (this.currentStep = 0);
    },
  },
};
</script>
<style lang="scss" scoped>
.home {
}
</style>
